import { capitalize } from "lodash";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import {
  useGlobalEffectActions,
  usePageContext,
  useRidesNavigation,
} from "@ryde/redux";
import {
  currencySignSelector,
  displayedRidesSeatsCountSF,
  displayedRidesTotalAmountSelector,
  displayedRowsCountSF,
  formatPrice,
  kanbanRidesCountWithInvalidOccupancySelector,
  selectedRidesSeatsCountSelector,
  selectedRidesTotalAmountSelector,
  selectedTableDataCountSF,
  useIsMobile,
} from "@ryde/shared";

import { EditGridColumnButton, PanelTopRightStatItem } from "../elements";
import {
  CarIcon,
  PanelStatStyled,
  PassengerIcon,
} from "./panel-top.stat.styled";

export const PanelTopStatRides: FC = () => {
  const { entity } = usePageContext();
  const { isMobile } = useIsMobile();
  const selectedSeatsCount = useRecoilValue(selectedRidesSeatsCountSelector);
  const seatsCount = useRecoilValue(displayedRidesSeatsCountSF(entity));
  const totalAmount = useRecoilValue(displayedRidesTotalAmountSelector);
  const totalAmountSelected = useRecoilValue(selectedRidesTotalAmountSelector);
  const selectedRidesCount = useRecoilValue(selectedTableDataCountSF(entity));
  const ridesCount = useRecoilValue(displayedRowsCountSF(entity));
  const invalidOccupancyRidesLength = useRecoilValue(
    kanbanRidesCountWithInvalidOccupancySelector,
  );

  const { isKanbanView } = useRidesNavigation();

  const { collapseExpandedRowsAppEvent } = useGlobalEffectActions();
  const { t } = useTranslation();
  const currencySign = useRecoilValue(currencySignSelector);

  return (
    <PanelStatStyled className="stat_mobile_align_end">
      {!!invalidOccupancyRidesLength && (
        <PanelTopRightStatItem
          e2eId="invalid-occupancy-rides"
          selected={invalidOccupancyRidesLength}
          hideTotal={true}
          muiPalette="error"
          label={t("errors.ridesWithInvalidOccupancy")}
        />
      )}
      {!isMobile && !isKanbanView && (
        <FramerTooltip content={t("general.COLLAPSE_ALL")}>
          <SVG_MUI.ArrowStatCollapse3SVG
            data-e2e="rides-collapse-all-arrow"
            onClick={collapseExpandedRowsAppEvent}
          />
        </FramerTooltip>
      )}
      <PanelTopRightStatItem
        e2eId="stat-rides-passengers-count"
        selected={selectedSeatsCount}
        total={seatsCount}
        label={isMobile ? <PassengerIcon /> : capitalize(t("ride.PASSENGERS"))}
      />
      <PanelTopRightStatItem
        e2eId="stat-rides-count"
        selected={selectedRidesCount}
        total={ridesCount}
        label={isMobile ? <CarIcon /> : capitalize(t("ride.plural"))}
      />
      <PanelTopRightStatItem
        e2eId="stat-rides-total-sum"
        selected={formatPrice({ value: totalAmountSelected })}
        total={formatPrice({ value: totalAmount })}
        label={currencySign}
      />
      {Boolean(isMobile) && (
        <div className="stat_panel_end">
          <EditGridColumnButton />
        </div>
      )}
    </PanelStatStyled>
  );
};
